export class ArrayUtils {
  public static isEmpty(T: any []): boolean {
    if (T && T.length && Array.isArray(T)) {
      return false;
    } else {
      return true;
    }
  }

  public static isNotEmpty(T: any []): boolean {
    if (T && T.length && Array.isArray(T)) {
      return true;
    } else {
      return false;
    }
  }
}
